import type { Role } from '@/stores/session';

/** Roles that manage the segment list — mirrors `crm.add/change_icpsegment`
 *  (Sales Manager, plus Founder / Super Admin). UX gate only; the server
 *  enforces (F2). Lead Gen reads segments to tag leads. */
export const ICP_SEGMENT_MANAGER_ROLES: readonly Role[] = ['super_admin', 'founder', 'sales_manager'];
